<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

    <PageTitle title="Schools" />

    <div class="columns">
      <div class="column is-12">
        <div class="card">
          <div class="card-content">
            <b-field>
              <b-button @click="addNewSchool()" type="is-info" size="is-small">Create a new school</b-button>
            </b-field>

            <b-modal :active.sync="modalNewSchool"
              has-modal-card
              trap-focus
              :destroy-on-hide="true"
              aria-role="dialog"
              aria-modal>
              <set-school :school_id="edit_school_id" @over="onSchoolModalOver"></set-school>
            </b-modal>

            <b-modal :active.sync="modalNewAdmin"
              has-modal-card
              trap-focus
              :destroy-on-hide="true"
              aria-role="dialog"
              aria-modal>
              <set-school-admin
                v-if="admin_school_id"
                :school_id="admin_school_id"
                :schoolName="admin_school_name"
                @over="modalNewAdmin = false"
              ></set-school-admin>
            </b-modal>

            <UpTable :paginated="true" :per-page="20" :data="fetchSchools" searchable>
              <UpTableColumn v-slot="props" field="name" label="Name" sortable>{{ props.row.name }}</UpTableColumn>
              <UpTableColumn v-slot="props" field="remarks" label="Remarks">{{ props.row.remarks }}</UpTableColumn>
              <UpTableColumn v-slot="props" field="status" label="Status" sortable>
                <b-tag :type="props.row.status ? 'is-success' : 'is-danger'">
                  {{ props.row.status ? 'Active' : 'Inactive' }}
                </b-tag>
              </UpTableColumn>
              <UpTableColumn v-slot="props" field="createdAt" label="Created At" sortable>
                {{ $common.formatDate(props.row.createdAt || props.row.created_at) }}
              </UpTableColumn>
              <UpTableColumn v-slot="props" label="Action">
                <div class="buttons">
                  <b-button
                    @click="addAdminFor(props.row)"
                    type="is-success"
                    size="is-small"
                    icon-left="account-plus"
                    title="Add School Admin / Teacher"
                  ></b-button>
                  <b-button
                    @click="editSchool(props.row._id)"
                    type="is-primary"
                    size="is-small"
                    icon-left="pencil"
                  ></b-button>
                  <b-button
                    @click="deleteThisSchool(props.row._id)"
                    type="is-danger"
                    size="is-small"
                    icon-left="delete"
                  ></b-button>
                </div>
              </UpTableColumn>
              <template #empty>
                <empty-table message="No schools created."></empty-table>
              </template>
            </UpTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PageTitle from '@/components/PageTitle'
import EmptyTable from '@/components/EmptyTable'
import SetSchool from '@/components/School/SetSchool'
import SetSchoolAdmin from '@/components/School/SetSchoolAdmin'

export default {
  name: 'SchoolsAdmin',
  components: { PageTitle, EmptyTable, SetSchool, SetSchoolAdmin },
  data(){
    return {
      isLoading : false,
      modalNewSchool : false,
      modalNewAdmin : false,
      edit_school_id : null,
      admin_school_id : null,
      admin_school_name : ''
    }
  },
  computed : {
    ...mapGetters(['fetchSchools', 'getTeacherToken'])
  },
  methods : {
    ...mapActions(['loadSchools', 'deleteSchool']),
    addNewSchool(){
      this.edit_school_id = null
      this.modalNewSchool = true
    },
    editSchool(id){
      this.edit_school_id = id
      this.modalNewSchool = true
    },
    addAdminFor(row){
      this.admin_school_id = row._id
      this.admin_school_name = row.name
      this.modalNewAdmin = true
    },
    onSchoolModalOver(){
      this.modalNewSchool = false
      this.edit_school_id = null
    },
    deleteThisSchool(id){
      this.$buefy.dialog.confirm({
        title: 'Delete this school',
        message : 'Are you sure you want to delete this school permanently?',
        type : 'is-danger',
        onConfirm: () => {
          this.deleteSchool({ id, token: this.getTeacherToken })
            .then(() => {
              this.$buefy.toast.open({ message: 'School deleted successfully', type: 'is-success' })
            })
            .catch(err => {
              this.$buefy.toast.open({
                message: (err.response && err.response.data && err.response.data.msg) || 'Could not delete',
                type: 'is-danger'
              })
            })
        }
      })
    }
  },
  async created(){
    this.isLoading = true
    try{
      await this.loadSchools({ token: this.getTeacherToken })
    }catch(err){
      this.$buefy.toast.open({
        message: (err.response && err.response.data && err.response.data.msg) || 'Could not load schools',
        type: 'is-danger'
      })
    }
    this.isLoading = false
  }
}
</script>
